import { ConcreteEncodable } from "./ConcreteEncodable";

import { CurrencyPairImplEncoder } from "../../encoder/CurrencyPairImplEncoder";

import * as CubiqTS from "../../index";
import { CurrencyPair } from "../CurrencyPair";

export class CurrencyPairImpl extends ConcreteEncodable implements CurrencyPair {
  public static enType: string = "com.bcdfx.model.CurrencyPairImpl";

  /*FID=1*/
  public base: string;
  /*FID=3*/
  public fwdEnabledFg: boolean;
  /*FID=4*/
  public fwdInvertDecimalsQty: number;
  /*FID=6*/
  public fwdRateDecimalsQty: number;
  /*FID=7*/
  public nonBase: string;
  /*FID=8*/
  public orderTempHotValue: CubiqTS.BigNumber | null = null;
  /*FID=9*/
  public orderTempWarmValue: CubiqTS.BigNumber | null = null;
  /*FID=10*/
  public pipsQty: number;
  /*FID=11*/
  public rateStaleTimeInSecs: CubiqTS.Long | null = null;
  /*FID=12*/
  public spotEnabledFg: boolean;
  /*FID=13*/
  public spotInvertDecimalsQty: number;
  /*FID=15*/
  public stamp: CubiqTS.Long | null = null;
  /*FID=16*/
  public ndfEnabledFg: boolean;
  /*FID=17*/
  public rateDecimalsQty: number;
  /*FID=18*/
  public spotDaysQty: number;
  /*FID=19*/
  public fixingDaysQty: CubiqTS.Long | null = null;
  /*FID=20*/
  public allowSpotFg: boolean;
  /*FID=21*/
  public allowFwdSpotTriggerFg: boolean;
  /*FID=22*/
  public allowFwdFwdTriggerFg: boolean;
  /*FID=25*/
  public allowNdfSpotTriggerFg: boolean;
  /*FID=26*/
  public allowNdfFwdTriggerFg: boolean;
  /*FID=27*/
  public allowValueNdfHolidayFg: boolean;
  /*FID=28*/
  public allowGammaOrdersFg: boolean;
  /*FID=29*/
  public allowTrailingOrdersFg: boolean;
  /*FID=30*/
  public allowInvertsFg: boolean;
  /*FID=31*/
  public ndfHorizonCd: CubiqTS.NdfHorizon;
  /*FID=32*/
  public temperatureTypeId: CubiqTS.UnitType;
  /*FID=33*/
  public spotPrecision: CubiqTS.Precision;
  /*FID=34*/
  public spotInvertPrecision: CubiqTS.Precision;
  /*FID=35*/
  public triggerManTpSpreadType: CubiqTS.TriggerLogicType;
  /*FID=36*/
  public triggerManSlSpreadType: CubiqTS.TriggerLogicType;
  /*FID=37*/
  public triggerManCallSpreadType: CubiqTS.TriggerLogicType;
  /*FID=38*/
  public triggerAutoTpSpreadType: CubiqTS.TriggerLogicType;
  /*FID=39*/
  public triggerAutoSlSpreadType: CubiqTS.TriggerLogicType;
  /*FID=40*/
  public triggerAutoCallSpreadType: CubiqTS.TriggerLogicType;
  /*FID=41*/
  public limitEntrySpotDecimals: number;
  /*FID=42*/
  public limitEntrySpotInvertDecimals: number;
  /*FID=43*/
  public tPFillTolerance: CubiqTS.BigNumber | null = null;
  /*FID=44*/
  public tPFillToleranceUnits: CubiqTS.UnitType;
  /*FID=45*/
  public sLFillTolerance: CubiqTS.BigNumber | null = null;
  /*FID=46*/
  public sLFillToleranceUnits: CubiqTS.UnitType;
  /*FID=47*/
  public entryRateTolerance: CubiqTS.BigNumber | null = null;
  /*FID=48*/
  public entryRateToleranceUnits: CubiqTS.UnitType;
  /*FID=49*/
  public fillRateTolerance: CubiqTS.BigNumber | null = null;
  /*FID=50*/
  public fillRateToleranceUnits: CubiqTS.UnitType;
  /*FID=51*/
  public failWrongSideOfMktFg: boolean;
  /*FID=52*/
  public markupSptDecimals: number;
  /*FID=53*/
  public markupSptInvDecimals: number;
  /*FID=54*/
  public fwdPipsQty: number;
  /*FID=55*/
  public fwdInvertPipsQty: number;
  /*FID=56*/
  public allowBmarkSpotOrdersFg: boolean;
  /*FID=57*/
  public allowBmarkFwdOrdersFg: boolean;
  /*FID=58*/
  public intArbLiquidReplenishAmt: number;
  /*FID=59*/
  public allowAlgoOrders: boolean;
  /*FID=60*/
  public allowInvertAlgoOrders: boolean;
  /*FID=61*/
  public additionalMidRoundingPrecision: number;
  /*FID=62*/
  public bmSpotPrecision: number;
  /*FID=63*/
  public bmSpotInvPrecision: number;
  /*FID=64*/
  public allowMarketOrdersFg: boolean;
  /*FID=65*/
  public allowAlgoFwdOrders: boolean;
  /*FID=66*/
  public slSlippagePips: CubiqTS.BigNumber | null = null;
  /*FID=67*/
  public minimumGammaDeltaPips: CubiqTS.Long | null = null;
  /*FID=68*/
  public entryAmtTolerance: CubiqTS.BigNumber | null = null;
  /*FID=69*/
  public trailingStopMinPips: CubiqTS.Long | null = null;
  /*FID=70*/
  public trailingStopMinInvPips: CubiqTS.Long | null = null;
  /*FID=71*/
  public allowNdfAlgoOrders: boolean;
  /*FID=72*/
  public adjustmentCalculationAutoThreshold: CubiqTS.BigNumber | null = null;
  /*FID=73*/
  public adjustmentCalculationManualThreshold: CubiqTS.BigNumber | null = null;
  /*FID=74*/
  public failWrongSideOfMktFutureFg: boolean;
  /*FID=75*/
  public termBaseEntry: CubiqTS.TermBaseEntry;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = CurrencyPairImplEncoder.Instance;
    this.setEncodableType(CurrencyPairImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "CurrencyPairImpl[" +
      "base=" +
      this.base +
      "fwdEnabledFg=" +
      this.fwdEnabledFg +
      "fwdInvertDecimalsQty=" +
      this.fwdInvertDecimalsQty +
      "fwdRateDecimalsQty=" +
      this.fwdRateDecimalsQty +
      "nonBase=" +
      this.nonBase +
      "orderTempHotValue=" +
      this.orderTempHotValue +
      "orderTempWarmValue=" +
      this.orderTempWarmValue +
      "pipsQty=" +
      this.pipsQty +
      "rateStaleTimeInSecs=" +
      this.rateStaleTimeInSecs +
      "spotEnabledFg=" +
      this.spotEnabledFg +
      "spotInvertDecimalsQty=" +
      this.spotInvertDecimalsQty +
      "stamp=" +
      this.stamp +
      "ndfEnabledFg=" +
      this.ndfEnabledFg +
      "rateDecimalsQty=" +
      this.rateDecimalsQty +
      "spotDaysQty=" +
      this.spotDaysQty +
      "fixingDaysQty=" +
      this.fixingDaysQty +
      "allowSpotFg=" +
      this.allowSpotFg +
      "allowFwdSpotTriggerFg=" +
      this.allowFwdSpotTriggerFg +
      "allowFwdFwdTriggerFg=" +
      this.allowFwdFwdTriggerFg +
      "allowNdfSpotTriggerFg=" +
      this.allowNdfSpotTriggerFg +
      "allowNdfFwdTriggerFg=" +
      this.allowNdfFwdTriggerFg +
      "allowValueNdfHolidayFg=" +
      this.allowValueNdfHolidayFg +
      "allowGammaOrdersFg=" +
      this.allowGammaOrdersFg +
      "allowTrailingOrdersFg=" +
      this.allowTrailingOrdersFg +
      "allowInvertsFg=" +
      this.allowInvertsFg +
      "ndfHorizonCd=" +
      this.ndfHorizonCd +
      "temperatureTypeId=" +
      this.temperatureTypeId +
      "spotPrecision=" +
      this.spotPrecision +
      "spotInvertPrecision=" +
      this.spotInvertPrecision +
      "triggerManTpSpreadType=" +
      this.triggerManTpSpreadType +
      "triggerManSlSpreadType=" +
      this.triggerManSlSpreadType +
      "triggerManCallSpreadType=" +
      this.triggerManCallSpreadType +
      "triggerAutoTpSpreadType=" +
      this.triggerAutoTpSpreadType +
      "triggerAutoSlSpreadType=" +
      this.triggerAutoSlSpreadType +
      "triggerAutoCallSpreadType=" +
      this.triggerAutoCallSpreadType +
      "limitEntrySpotDecimals=" +
      this.limitEntrySpotDecimals +
      "limitEntrySpotInvertDecimals=" +
      this.limitEntrySpotInvertDecimals +
      "tPFillTolerance=" +
      this.tPFillTolerance +
      "tPFillToleranceUnits=" +
      this.tPFillToleranceUnits +
      "sLFillTolerance=" +
      this.sLFillTolerance +
      "sLFillToleranceUnits=" +
      this.sLFillToleranceUnits +
      "entryRateTolerance=" +
      this.entryRateTolerance +
      "entryRateToleranceUnits=" +
      this.entryRateToleranceUnits +
      "fillRateTolerance=" +
      this.fillRateTolerance +
      "fillRateToleranceUnits=" +
      this.fillRateToleranceUnits +
      "failWrongSideOfMktFg=" +
      this.failWrongSideOfMktFg +
      "markupSptDecimals=" +
      this.markupSptDecimals +
      "markupSptInvDecimals=" +
      this.markupSptInvDecimals +
      "fwdPipsQty=" +
      this.fwdPipsQty +
      "fwdInvertPipsQty=" +
      this.fwdInvertPipsQty +
      "allowBmarkSpotOrdersFg=" +
      this.allowBmarkSpotOrdersFg +
      "allowBmarkFwdOrdersFg=" +
      this.allowBmarkFwdOrdersFg +
      "intArbLiquidReplenishAmt=" +
      this.intArbLiquidReplenishAmt +
      "allowAlgoOrders=" +
      this.allowAlgoOrders +
      "allowInvertAlgoOrders=" +
      this.allowInvertAlgoOrders +
      "additionalMidRoundingPrecision=" +
      this.additionalMidRoundingPrecision +
      "bmSpotPrecision=" +
      this.bmSpotPrecision +
      "bmSpotInvPrecision=" +
      this.bmSpotInvPrecision +
      "allowMarketOrdersFg=" +
      this.allowMarketOrdersFg +
      "allowAlgoFwdOrders=" +
      this.allowAlgoFwdOrders +
      "slSlippagePips=" +
      this.slSlippagePips +
      "minimumGammaDeltaPips=" +
      this.minimumGammaDeltaPips +
      "entryAmtTolerance=" +
      this.entryAmtTolerance +
      "trailingStopMinPips=" +
      this.trailingStopMinPips +
      "trailingStopMinInvPips=" +
      this.trailingStopMinInvPips +
      "allowNdfAlgoOrders=" +
      this.allowNdfAlgoOrders +
      "adjustmentCalculationAutoThreshold=" +
      this.adjustmentCalculationAutoThreshold +
      "adjustmentCalculationManualThreshold=" +
      this.adjustmentCalculationManualThreshold +
      "failWrongSideOfMktFutureFg=" +
      this.failWrongSideOfMktFutureFg +
      "termBaseEntry=" +
      this.termBaseEntry +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
